var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGears71(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.58,125.3a15.93,15.93,0,1,0,7.33,21.3A15.94,15.94,0,0,0,88.58,125.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.23,98.34l-7,14.44,1.94,1.69A34.53,34.53,0,0,1,110,121l1.43,2.12,14.77-5.09,4.1,11.9-14.59,5,.21,2.59a35,35,0,0,1-.46,9.33l-.48,2.5,13.38,6.53-5.52,11.32-13.24-6.46-1.68,2a34.43,34.43,0,0,1-7.31,6.5l-2.15,1.43,4.65,13.53-11.91,4.1-4.68-13.58-2.55.17a34.23,34.23,0,0,1-9.91-.76l-2.57-.57-6.25,12.8-11.33-5.52,6.39-13.11-1.85-1.69a34,34,0,0,1-6.17-7.44l-1.41-2.28L37,161.17l-4.11-11.91,14.43-5-.1-2.49a34.3,34.3,0,0,1,.9-9.14l.61-2.59-13.9-6.78L40.31,112l14.33,7,1.68-1.82a35,35,0,0,1,6.73-5.59l2.2-1.41L60,95,72,90.87l5.31,15.41,2.52-.14a34.27,34.27,0,0,1,8.56.63l2.53.51,7-14.46,11.31,5.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.92,63.68a12.34,12.34,0,1,0,13,11.68A12.35,12.35,0,0,0,145.92,63.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.81,37.68l.64,12.42,1.94.42a26.7,26.7,0,0,1,6.47,2.24l1.77.9,8.09-9L176,51.2l-8,8.87,1.11,1.68a26.4,26.4,0,0,1,3.18,6.49l.62,1.88,11.51-.6.5,9.74-11.39.59-.39,2A26.68,26.68,0,0,1,170.58,89l-.92,1.78,8.22,7.42-6.53,7.24L163.09,98,161.42,99a27.06,27.06,0,0,1-7,3.2l-2,.57.56,11-9.74.5-.58-11.28-1.89-.44a26.83,26.83,0,0,1-7-2.74l-1.8-1-7.65,8.48-7.25-6.53L125.06,92l-1-1.65a26.25,26.25,0,0,1-2.82-6.53l-.56-2-12,.62-.51-9.73,12.33-.64.46-1.86a26.59,26.59,0,0,1,2.46-6.31l1-1.79-9.21-8.32,6.53-7.24L131.12,55l1.66-1a26.22,26.22,0,0,1,6-2.78l1.9-.6-.64-12.44,9.73-.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGears71);
export default __webpack_public_path__ + "static/media/GEARS_71.085384e1be314058251b1836a4b30418.svg";
export { ForwardRef as ReactComponent };